'use client';

import styled from 'styled-components';

import { SkeletonAnimation } from '@/styles/animation';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0px 20px 10px;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const LoadMoreButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  gap: 5px;

  &::after {
    content: '';
    width: 24px;
    height: 24px;
    background-image: url('/images/icon/arw_down_black2.svg');
    background-repeat: no-repeat;
    background-size: contain;
  }
`;

// Skeleton UI
const Skeleton = styled.div`
  ${SkeletonAnimation};
  width: 100%;
  border-radius: 10px;
  aspect-ratio: 16/9;
`;

// Empty UI
const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 240px;
`;

const EmptyTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const EmptyTitle = styled.p`
  color: ${({ theme }) => theme.rootColor.black12};
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  word-break: keep-all;
`;

const EmptyDescription = styled.p`
  color: ${({ theme }) => theme.rootColor.gray7B};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  word-break: keep-all;
`;

const OriginalsSectionStyled = {
  Container,
  ListContainer,
  LoadMoreButton,
  Skeleton,
  EmptyContainer,
  EmptyTextWrapper,
  EmptyTitle,
  EmptyDescription,
};

export default OriginalsSectionStyled;
